import { useRef, useEffect } from "react";

function useClickOutside(ref, onClick) {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target) && !!onClick) {
                onClick(event);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export const ClickOutside = ({ children, onClick }) => {
    const ref = useRef(null);
    useClickOutside(ref, onClick);

    return <div ref={ref}>{children}</div>;
};
